// extracted by mini-css-extract-plugin
export var stepActive = "_2a-3";
export var stepCompleted = "_2a-4";
export var stepConnectorLine = "_2a-b";
export var stepIndicatorCircle = "_2a-6";
export var stepIndicatorCircleCompleted = "_2a-7";
export var stepIndicatorCircleDefault = "_2a-8";
export var stepIndicatorTextCompleted = "_2a-9";
export var stepIndicatorTextDefault = "_2a-a";
export var stepPending = "_2a-5";
export var wizardContainer = "_2a-1";
export var wizardContent = "_2a-2";
export var wizardModal = "_2a-0";